export default __webpack_public_path__ + "favicon_sgate.ico";